import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { ContainerDashboardPanel } from '../features/containers/components/ContainerDashboardPanel';

const ContainersPage: React.FC = () => {
  const { authFetch } = useAuth();
  return (
    <div className="page-container">
      <ContainerDashboardPanel authFetch={authFetch} />
    </div>
  );
};

export default ContainersPage;
